exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "[contenteditable]:focus{outline:0 solid transparent}", "", {"version":3,"sources":["D:/A32/Atlant/dealger_spring_1/client/src/components/common/FlexField.vue"],"names":[],"mappings":"AACA,wBACE,2BAA+B,CAChC","file":"FlexField.vue","sourcesContent":["\n[contenteditable]:focus {\n  outline: 0px solid transparent;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-25d0da96","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/common/FlexField.vue
// module id = 820
// module chunks = 1